import React from "react";
import styled, {css} from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import {Paragraph} from "BaseComponents/Text";
import {ButtonText, ColoredButton} from "BaseComponents/Button";
import {Arrow} from "BaseComponents/Icons/Svg";
import {Cog} from "../../BaseComponents/Icons/Svg";
import {useGlobal} from "reactn";
import {PageWrapper} from "BaseComponents/Wrappers";
import {getResponsiveImage} from "Helpers/ImageHelper";

export const ErrorPageWrapper = styled.div`
    width: 100%;
    padding: 5rem 1rem;

    ${({bgImage}) =>
            bgImage &&
            css`
                background-image: ${({bgImage}) => `url(${bgImage})`};
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
            `}

    ${media.greaterThan(breakpoints.ipad)`
     min-height: 800px;
     `}
`;
export const ErrorPageContentWrapper = styled.div`
    flex-direction: column;
    display: flex;
    max-width: 800px;
    margin: 0 auto;
`;
export const HeaderWrapper = styled.div`
    display: flex;
    margin: 1rem 0;
    justify-content: space-between;
    align-items: center;
`;
export const ErrorHeader = styled.h1`
    color: ${({theme}) => theme.colors.primary};
    font-size: 120px;
    margin: 2rem 0rem;
`;

export const Underline = styled.div`
    border-bottom: 3px solid ${({theme}) => theme.colors.grey};
    height: 10px;
`;

export const ErrorIngress = styled.p`
    display: inline-block;
    font-size: 24px;
    line-height: 1.38;
    margin: 1rem 0 1rem 0;
`;
export const ErrorButton = styled(ColoredButton)`
    svg {
        stroke: ${({theme}) => theme.colors.black};
    }

    &:hover {
        svg {
            stroke: white;
        }
    }
`;

const ErrorPage = ({
                       Heading,
                       ErrorText,
                       CurrentStartPage,
                       ErrorCode,
                       StartPageLinkText = "Startsida",
                       ResponsiveImage
                   }) => {
    const [theme] = useGlobal("theme");
    const responsiveImage = getResponsiveImage(ResponsiveImage);
    return (
        <>
            <ErrorPageWrapper bgImage={responsiveImage}>
                <ErrorPageContentWrapper>
                    <HeaderWrapper>
                        <ErrorHeader size="120px">{ErrorCode}</ErrorHeader>
                        <Cog color={theme.colors.secondary} width="74px" height="60px"/>
                    </HeaderWrapper>
                    <Paragraph fontWeight="500" fontSize="18px">{Heading}</Paragraph>
                    <Underline/>
                    <ErrorIngress  dangerouslySetInnerHTML={{
                        __html: ErrorText,
                    }}/>
                    <ErrorButton
                        widthsmall="180px"
                        borderradius="500px"
                        height="50px"
                        bgColor={theme.colors.darkgrey}
                        href={CurrentStartPage}
                    >
                        <ButtonText heading={`error button ${StartPageLinkText}`}>{StartPageLinkText}</ButtonText>
                        <Arrow></Arrow>
                    </ErrorButton>
                </ErrorPageContentWrapper>
            </ErrorPageWrapper>
        </>
    );
};

export default ErrorPage;
